import React from "react";
import { TSignedInWorkerState } from "../../../_model/repos/interfaces/IAuthRepo";

const WorkerCompanyRouteContext = React.createContext<TSignedInWorkerState>(
  {} as never
);

export default WorkerCompanyRouteContext;
